import React from 'react';
import { DateTHShort, DateTimeToTime, MonthTH_Short } from '../../app_components/DateTH';

const PrizeHistoryList = ({ prizesHistory }) => {
    // ตัวอย่างข้อมูล
    const prizes = prizesHistory;

    return (
        prizes.length > 0 ? <div className="w-full max-w-md mx-auto space-y-4" >
            <h2 className="text-xl font-bold  text-gray-800">ประวัติรางวัล</h2>
            <span className='' style={{ fontSize: 14, color: '#000000' }}>
                - รวบรวมของรางวัลที่ได้ ภายใน วันที่ 2 ก.พ. 68 <br />
                - จัดส่งของแถมให้พร้อมรอบบิลถัดไป ตั้งแต่ วันที่ 2 ก.พ. 68
            </span>

            <div className="bg-white rounded-lg shadow-md divide-y divide-gray-200">
                {prizes.map((prize, index) => (
                    <div
                        key={`${prize.option}-${index}`}
                        className="p-4 hover:bg-gray-50 transition-colors duration-150"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                                <i className="fa-solid fa-gift text-orange-500"></i>
                                <div className="flex flex-col">
                                    <span className="font-medium text-gray-800">
                                        {prize.PRODNAME}
                                    </span>
                                    <div className="flex items-center text-sm text-gray-500 mt-1">
                                        <span className=''> ได้รับล่าสุด : {DateTHShort(prize.RC_DT)}  {DateTimeToTime(prize.RC_DT)} น.</span>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center">
                                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium text-center">
                                    ได้รับรวม {prize.SUM_QTY} {prize.UNITNAME}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div > : null
    );
};

export default PrizeHistoryList;